import React, { Component } from 'react'
import { StyledContainer } from './mTextInputDynamic.style'
import { TextInput, TextArea } from '@volkswagen-onehub/components-core'

import {
  TEXT_INPUT_DYNAMIC_TEXT,
  TEXT_INPUT_DYNAMIC_EMAIL,
  TEXT_INPUT_DYNAMIC_AREA,
  TEXT_INPUT_DYNAMIC_PHONE,
  TEXT_INPUT_DYNAMIC_CAR_REG,
  TEXT_INPUT_DYNAMIC_POSTCODE
} from 'form/store/form/constants.js'

class TextInputDynamic extends Component {
  getPattern = type => {
    /* eslint-disable no-useless-escape */
    const pattern = {
      postcode: /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/,
      phone: /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/,
      registration: /^[0-9a-zA-Z- ']+$/,
      // registration: /(^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(^[A-Z][0-9]{1,3}[A-Z]{3}$)|(^[A-Z]{3}[0-9]{1,3}[A-Z]$)|(^[0-9]{1,4}[A-Z]{1,2}$)|(^[0-9]{1,3}[A-Z]{1,3}$)|(^[A-Z]{1,2}[0-9]{1,4}$)|(^[A-Z]{1,3}[0-9]{1,3}$)|(^[A-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)$/,
      area: /^[\W\S]{2,}$/,
      text: /^[a-zA-Z- ']+$/,
      email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
    return pattern[type]
  }
  render() {
    const { handleInputChange, getInputStyle, cmsData, type } = this.props
    cmsData.pattern = this.getPattern(type)

    // Function to add character limit to textarea element.
    const handleTextAreaInputChange = (event, cmsData) => {
      const maxLength = cmsData.maxlength
      if (maxLength) {
        event.target.value = event.target.value.toString().slice(0, maxLength)
      }
      handleInputChange(event, cmsData)
    }

    return (
      <StyledContainer
        className={[
          cmsData.noLabel ? 'no-label' : '',
          cmsData.reducedHeight ? 'small' : ''
        ].join(' ')}
      >
        {(type === TEXT_INPUT_DYNAMIC_TEXT ||
          type === TEXT_INPUT_DYNAMIC_PHONE ||
          type === TEXT_INPUT_DYNAMIC_POSTCODE ||
          type === TEXT_INPUT_DYNAMIC_CAR_REG) && (
          <TextInput
            key={cmsData.name}
            label={cmsData.label}
            defaultValue={cmsData.value}
            placeholder={cmsData.placeholder}
            appearance={getInputStyle(cmsData.name)}
            onChange={e => handleInputChange(e, cmsData)}
            validText={cmsData.error}
            required={cmsData.required}
            errorText={cmsData.error}
          />
        )}
        {type === TEXT_INPUT_DYNAMIC_EMAIL && (
          <TextInput
            key={cmsData.name}
            label={cmsData.label}
            defaultValue={cmsData.value}
            placeholder={cmsData.placeholder}
            appearance={getInputStyle(cmsData.name)}
            onChange={e => handleInputChange(e, cmsData)}
            validText={cmsData.error}
            required={cmsData.required}
            errorText={cmsData.error}
          />
        )}
        {type === TEXT_INPUT_DYNAMIC_AREA && (
          <TextArea
            key={cmsData.name}
            label={cmsData.label}
            defaultValue={cmsData.value}
            placeholder={cmsData.placeholder}
            appearance={getInputStyle(cmsData.name)}
            onChange={e => handleTextAreaInputChange(e, cmsData)}
            validText={cmsData.error}
            required={cmsData.required}
            errorText={cmsData.error}
          />
        )}
      </StyledContainer>
    )
  }
}

export default TextInputDynamic
